import { createSlice } from '@reduxjs/toolkit';
import { RootState } from './store';

// Define a type for the slice state
interface AppointmentDataProps {
  title: string;
  date: string;
  time_from: string;
  time_to: string;
  timeZoneName: string;
  servedAt: string;
  price: string;
  currency?: string;
  currency_label?: string;
  host: string;
  visible_to: number;
  appointmentId?: number;
  rescheduled?: boolean;
  appointment?: any;
  description: string;
  duration?: string;
  hide_duration?: boolean;
  canceled?: boolean;
  appointment_id?: string;
  client_slug?: string;
  oldAppointment?: any;
  served_at_value?: number;
  served_at_data?: string;
  email?: string;
  ics?: string;
  appointment_nr?: string;
  access_token?: string;
  payment_hold_expires_at?: string;
  has_e_payment?: boolean;
}

const initialState: AppointmentDataProps = {
  title: '',
  date: '',
  time_from: '',
  time_to: '',
  timeZoneName: '',
  servedAt: '',
  price: '',
  host: '',
  visible_to: 0,
  rescheduled: false,
  description: '',
  oldAppointment: {},
  served_at_data: '',
  email: '',
  has_e_payment: true,
};

export const appointmentDataSlice = createSlice({
  name: 'appointmentData',
  initialState,
  reducers: {
    setAppointmentData: (state, { payload: data }) => {
      return data;
    },
    clearAppointmentData: (state) => {
      return initialState;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAppointmentData, clearAppointmentData } =
  appointmentDataSlice.actions;

export const getAppointmentData = (state: RootState) => state.appointmentData;

export default appointmentDataSlice.reducer;
